<template>
  
  <div class="d-flex justify-end align-center  pa-3">
    <v-row>
      <v-col cols="12">
        <v-icon class="icon-border" @click="prePagination">
          mdi-chevron-left </v-icon
        >{{ pagtotals === 0 ? 0 : isPage }}/{{ paginationLength(pagtotals)
        }}<v-icon class="icon-border mr-2" @click="nextPagination">
          mdi-chevron-right
        </v-icon>
      </v-col>
      <v-col cols="12" xs="3" class="pa-0">
        แสดง
      </v-col>
      <v-col cols="12" xs="3" class="pa-0">
        <span class="icon-border px-2 mx-2 text-296ED5">
         {{ showItemMin() }}-{{ showItemMax() }} ของ {{ pagtotals }} 
        </span>
      </v-col>
      <v-col cols="12" xs="3" class="pa-0">
        รายการ
      </v-col>
    </v-row>

  </div>
</template>

<script>
export default {
  props: {
    totals: {
      type: Number,
      default: 1,
    },
    isPage: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      page: 1,
      itemMin: 1,
    };
  },
  computed: {
    pagtotals() {
      return this.totals;
    },
  },
  methods: {
    paginationLength(total = 0) {
      if (total % 10 === 0) {
        return total / 10;
      } else return Math.floor(total / 10) + 1;
    },
    prePagination() {
      this.page = this.isPage;
      if (this.isPage !== 1) {
        this.page -= 1;
        this.itemMin -= 10;
        this.$emit("page", this.page);
      }
    },
    nextPagination() {
      //
      this.page = this.isPage;
      // console.log(parseInt(this.totals / 10));
      if (this.totals / 10 > this.isPage)
        if (
          this.isPage <= Math.floor(this.pagtotals / 10) &&
          this.pagtotals > 10
        ) {
          this.page += 1;
          this.itemMin += 10;
          this.$emit("page", this.page);
        }
    },
    showItemMin() {
      if (this.isPage === 1) this.itemMin = 1;
      if (this.pagtotals === 0) return 0;
      return this.itemMin;
    },
    showItemMax() {
      if (this.itemMin + 9 > this.pagtotals) return this.pagtotals;
      return this.itemMin + 9;
    },
  },
};
</script>

<style></style>
